import { smsFilterableFields } from 'components/Filters/catalogues/smsFilterableFields.jsx'
import FilterBarCore from 'components/Filters/FilterBarCore'

export default function SMSFilterBar({ appliedFilters, appliedMode }) {
  return (
    <FilterBarCore
      filterableFields={smsFilterableFields}
      appliedFilters={appliedFilters}
      appliedMode={appliedMode}
      defaultNewFilter={{ field: 'conversation_id', operator: 'equals', value: '' }}
      pathwayFieldKey="curr_pathway_id"
    />
  )
}
